import { Link, useNavigate, useLocation } from 'react-router';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { MenuItem, MenuSection, Header } from 'react-aria-components';
import { NavigateRoutesEnum } from '@features/routing/routesEnum';
import { MenuButton } from 'components/menu-button/MenuButton';
import { menuDefinition } from '@layouts/toolbar/menuDefinition';
import { useHasPermission } from '@hooks/has-permission/useHasPermission';



const SmallMenu = () => {

	const navigate = useNavigate();
	const location = useLocation();
	const hasPermission = useHasPermission();

	return (
		<MenuButton
			icon={faBars}
			className='menu-small-icon'
			autoFocus={false}
			onAction={(key: string | number | bigint) => {
				navigate(String(key));
			}}>
			{menuDefinition.map(x => x.items && x.items.length > 0
				?
					(<MenuSection key={x.id}>
						<Header>{x.name}</Header>
						{x.items.map(y =>
							<MenuItem
								key={y.id}
								id={y.id}
								textValue={y.name}
								isDisabled={y.requiredRoles ? !hasPermission(y.requiredRoles) : false}>
									<Link to={y.id}>{y.name}</Link>
							</MenuItem>
						)}
					</MenuSection>)
				:
					(<MenuItem
						key={x.id}
						id={x.id}
						textValue={x.name}
						isDisabled={x.requiredRoles ? !hasPermission(x.requiredRoles) : false}>
							<Link to={x.id}>{x.name}</Link>
					</MenuItem>)
			)}
			<MenuItem id={NavigateRoutesEnum.search} textValue='Vyhledávání' className={`react-aria-MenuItem search-item${location.pathname === NavigateRoutesEnum.search ? ' active-search' : ''}`}>
				<Link to={NavigateRoutesEnum.search}>Vyhledávání</Link>
			</MenuItem>
		</MenuButton>
	);
}

export default SmallMenu;